// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* TAG STATUS */\n/* VIEW */\n.form-title[data-v-05455f86] {\n  padding: 0 16px;\n  color: #717171;\n  background-color: #fafafa;\n  gap: 10px;\n}\n.form-title .title-text[data-v-05455f86] {\n  width: 100%;\n  padding: 4px 8px;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
